export const getScoreColor = (score: number): { bg: string; text: string; progress: string } => {
    if (score >= 75)
        return {
            bg: "bg-green-100",
            text: "text-green-600",
            progress: "bg-green-500",
        };
    if (score >= 50)
        return {
            bg: "bg-blue-100",
            text: "text-blue-600",
            progress: "bg-blue-500",
        };
    if (score >= 25)
        return {
            bg: "bg-amber-100",
            text: "text-amber-600",
            progress: "bg-amber-500",
        };
    return {
        bg: "bg-slate-100",
        text: "text-slate-500",
        progress: "bg-slate-500",
    };
};

export const formatBulletsToHtml = (bullets: string) : string => {
    if (!bullets) return "";
    return `<ul class="list-disc pl-4 space-y-1">
      ${bullets
        .split("\n")
        .map((bullet) => {
          // Split on first colon and wrap the title part in <strong> tags
          const [title, ...rest] = bullet.split(":");
          if (rest.length > 0) {
            return `<li><strong>${title}</strong>:${rest.join(":")}</li>`;
          }
          // If no colon found, return as is
          return `<li>${bullet}</li>`;
        })
        .join("")}
    </ul>`;
  };